import { ConfirmService } from '../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Guards } from '../../../interfaces/guards';

@Component({
  selector: 'app-list-guard',
  templateUrl: './list-guard.component.html',
  styleUrls: ['./list-guard.component.css']
})
export class ListGuardComponent implements OnInit {

  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService, private confirm: ConfirmService,
  ) { }

  view: number = 1;
  status: any;
  selected?: Guards;
  ngOnInit(): void {
    localStorage.removeItem('endPoint');
    localStorage.setItem('endPoint',"4");
    this.get();
    this.loadPositions();
    this.api.getAllFacility().subscribe(
      (response) => (this.facilities = (response.data as any[]) ?? []),
      () => (this.facilities = [])
    );
  }
  items: Guards[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  form = new UntypedFormGroup({
    q: new UntypedFormControl(''),
    state_id: new UntypedFormControl(''),
    os10: new UntypedFormControl(''),
    position_id: new UntypedFormControl('')
  });
  facilities: any[] = [];
  positions: { id: number; name: string; color: string | null; guards: number }[] = [];

  secondForm = new UntypedFormGroup({
    id: new UntypedFormControl(),
  });
  delete() {
    this.secondForm.get('id')?.setValue(this.selected?.id);
    this.api.deleteGuards(this.secondForm).subscribe(
      (res) => {
        this.toast.success('Usuario eliminado correctamente', 'GUARDIAS');
        this.get();
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.msg, { enableHtml: true, closeButton: true });
      }
    );
  }
  get() {
    this.api.paginateGuards(this.page,this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Guards[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;

        this.totalPage = data.total;
      },
      (error) => {
        this.items = [];
        this.page = 1;
      }
    );
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openDelete(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  openEdit(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  // ------------------------------------------------------- cargos del personal

  @ViewChild('positionsTpl', { static: true }) positionsTemplate!: TemplateRef<unknown>;
  posEditing: { id?: number | null; name: string; color: string } = { name: '', color: '#6c757d' };
  posBusy = false;

  loadPositions() {
    this.api.getGuardPositions().subscribe(
      (res) => (this.positions = (res.data as any[]) ?? []),
      () => (this.positions = [])
    );
  }

  openPositions() {
    this.posEditing = { name: '', color: '#6c757d' };
    this.loadPositions();
    this.modal.open(this.positionsTemplate, { size: 'md', backdrop: 'static' });
  }

  editPosition(p: { id: number; name: string; color: string | null }) {
    this.posEditing = { id: p.id, name: p.name, color: p.color || '#6c757d' };
  }

  savePosition() {
    const name = this.posEditing.name.trim();
    if (name.length < 2) {
      this.toast.warning('El nombre del cargo debe tener al menos 2 caracteres', 'CARGOS');
      return;
    }
    this.posBusy = true;
    this.api.saveGuardPosition({ id: this.posEditing.id, name, color: this.posEditing.color }).subscribe(
      (res) => {
        this.posBusy = false;
        this.toast.success(res.msg, 'CARGOS');
        this.posEditing = { name: '', color: '#6c757d' };
        this.loadPositions();
        this.get();
      },
      (e) => {
        this.posBusy = false;
        this.toast.warning((e.error?.mistakes ?? []).join(' · ') || e.error?.msg, 'CARGOS');
      }
    );
  }

  async deletePosition(p: { id: number; name: string; guards: number }) {
    const extra = p.guards > 0 ? ` ${p.guards} guardia(s) quedarán sin cargo.` : '';
    if (!(await this.confirm.ask({ title: 'Eliminar cargo', message: `¿Eliminar el cargo «${p.name}»?${extra}`, confirmLabel: 'Eliminar', danger: true }))) return;
    this.posBusy = true;
    this.api.deleteGuardPosition(p.id).subscribe(
      (res) => {
        this.posBusy = false;
        this.toast.success(res.msg, 'CARGOS');
        this.loadPositions();
        this.get();
      },
      (e) => {
        this.posBusy = false;
        this.toast.warning(e.error?.msg, 'CARGOS');
      }
    );
  }

  // ------------------------------------------------------- altas y bajas masivas (RRHH)

  @ViewChild('rrhhTpl', { static: true }) rrhhTemplate!: TemplateRef<unknown>;
  rrhhKind: 'terminations' | 'workers' = 'terminations';
  rrhhFile: File | null = null;
  rrhhReview: any = null;
  rrhhBusy = false;
  rrhhError = '';
  readonly rrhhActionLabel: Record<string, string> = {
    delete: 'Se eliminará',
    already_deleted: 'Ya estaba eliminado',
    not_found: 'No está registrado',
    invalid_rut: 'RUT inválido',
    duplicate: 'Repetido en el archivo',
    create: 'Se agregará',
    reactivate: 'Se reactivará',
    exists: 'Ya existe',
    skipped_terminated: 'Con fecha de término',
  };
  /** Acciones que cambian datos; el resto solo se informan. */
  private readonly rrhhActive = ['delete', 'create', 'reactivate'];

  openRrhh(kind: 'terminations' | 'workers') {
    this.rrhhKind = kind;
    this.rrhhFile = null;
    this.rrhhReview = null;
    this.rrhhError = '';
    this.modal.open(this.rrhhTemplate, { size: 'lg', scrollable: true, backdrop: 'static' });
  }

  get rrhhTitle(): string {
    return this.rrhhKind === 'terminations' ? 'Desvincular guardias (bajas masivas)' : 'Agregar guardias nuevos (altas masivas)';
  }

  get rrhhHelp(): string {
    return this.rrhhKind === 'terminations'
      ? 'Suba el archivo de finiquitos del sistema de RRHH. Los guardias cuyo RUT aparezca se eliminan (quedan guardados, ocultos y sin acceso a la app).'
      : 'Suba la tabla de trabajadores del sistema de RRHH. Se agregan los RUT que no existen; quien estaba desvinculado se reactiva y nadie se duplica.';
  }

  get rrhhPending(): number {
    return this.rrhhActive.reduce((n, a) => n + (this.rrhhReview?.counts?.[a] ?? 0), 0);
  }

  rrhhCountEntries(): [string, number][] {
    return Object.entries(this.rrhhReview?.counts ?? {}) as [string, number][];
  }

  rrhhPick(ev: Event) {
    this.rrhhFile = (ev.target as HTMLInputElement).files?.[0] ?? null;
    this.rrhhReview = null;
    this.rrhhError = '';
  }

  rrhhRun(apply: boolean) {
    if (!this.rrhhFile || this.rrhhBusy) return;
    this.rrhhBusy = true;
    this.rrhhError = '';
    this.api.importGuardsRrhh(this.rrhhKind, this.rrhhFile, apply).subscribe(
      (res) => {
        this.rrhhBusy = false;
        this.rrhhReview = res.data as any;
        if (apply) {
          const d = (res.data as any).done;
          this.toast.success(`Eliminados: ${d.deleted} · Agregados: ${d.created} · Reactivados: ${d.reactivated}`, 'GUARDIAS', { timeOut: 8000 });
          this.modal.dismissAll();
          this.get();
        }
      },
      (e) => {
        this.rrhhBusy = false;
        this.rrhhError = [e.error?.msg, ...(e.error?.mistakes ?? [])].filter(Boolean).join(' · ') || 'No fue posible procesar el archivo.';
      }
    );
  }

  clean(){
    this.form.get('q').setValue('');
    this.form.get('state_id').setValue('');
    this.form.get('os10').setValue('');
    this.form.get('position_id').setValue('');
    this.page=1;
    this.get();
  }

  filterChange() {
    this.page = 1;
    this.get();
  }

  search(q:string='') {
    if(q.length>=2){
      this.form.get('q').setValue(q);
      console.log('result q:',q);
      this.page=1;
    }
    this.get();
  }
}

